import styled from 'styled-components';

export const Content = styled.div``;

/** Status and confirmation sit together, inline with the title. */
export const HeadChips = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s2);
`;

export const DateCell = styled.div`
  display: flex;
  align-items: baseline;
  gap: var(--s2);
`;

/** The day name the payload sends and the screen never showed. */
export const WeekDay = styled.span`
  font-size: var(--fs-micro);
  font-weight: var(--fw-regular);
  color: var(--text-faint);
`;

export const Body = styled.div`
  padding: var(--s5);
`;

/** The design's `.subhead`. */
export const SubHead = styled.div`
  margin-bottom: var(--s3);
  font-size: var(--fs-th);
  font-weight: var(--fw-semibold);
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-faint);
`;

/**
 * The design's `.grid-2`. Two person cards to a row, collapsing to one on a
 * narrow card — the same 1100px the sidebar collapses at.
 */
export const People = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--s4);

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

export const NoPeople = styled.p`
  margin: 0;
  font-size: var(--fs-body);
  color: var(--text-faint);
`;

/** The design's `.actionbar` — the card's foot. */
export const ActionBar = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s2);
  padding: var(--s4) var(--s5);
  border-top: 1px solid var(--line);
  background: var(--surface-alt);
`;

export const Spacer = styled.div`
  flex: 1;
`;
